module.exports = __webpack_public_path__ + "static/media/material_incomplete.f7996829.svg";